// App Imports
import { LIST_REQUEST, LIST_RESPONSE, LIST_DONE, GROUPS_RESPONSE } from '../../actions/types'

// Initial State
const documentsInitialState = {
  isLoading: false,
  list: [],
  count: 0,
  groups: []
}

// Reducer
const documentsReducer = (state = documentsInitialState, action) => {
  switch (action.type) {
    case LIST_REQUEST:
      return {
        ...state,
        isLoading: action.isLoading
      }

    case LIST_RESPONSE:
      return {
        ...state,
        list: action.list,
        count: action.count || 0
      }

    case GROUPS_RESPONSE:
      return {
        ...state,
        groups: action.groups
      }

    case LIST_DONE:
      return {
        ...state,
        isLoading: false
      }

    default:
      return state
  }
}

export default documentsReducer;
